module.exports = __webpack_public_path__ + "img/1515292830.73c885b9.jpg";